export const ContractVehicleDamageMap = ({
  vehicle,
  contractSettings,
  reservation,
}) => {
  return null;
};
